/**
 * @generated SignedSource<<fb808674ef2b69742b052666cb1381fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CutOffTable_table$data = {
  readonly entries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly currency: string | null | undefined;
        readonly cutOffTime: string | null | undefined;
        readonly frequency: string | null | undefined;
        readonly frequencyComment: string | null | undefined;
        readonly id: string;
        readonly isin: string | null | undefined;
        readonly name: string | null | undefined;
        readonly salesAdmission: ReadonlyArray<string | null | undefined> | null | undefined;
        readonly valueDate: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CutOffTableHeader_header">;
  readonly " $fragmentType": "CutOffTable_table";
};
export type CutOffTable_table$key = {
  readonly " $data"?: CutOffTable_table$data;
  readonly " $fragmentSpreads": FragmentRefs<"CutOffTable_table">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CutOffTable_table",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "CoTrancheConnection",
      "kind": "LinkedField",
      "name": "entries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CoTrancheEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CoTranche",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isin",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "frequency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "frequencyComment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cutOffTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "valueDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "salesAdmission",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "entries(first:1000)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CutOffTableHeader_header"
    }
  ],
  "type": "CutOffTable",
  "abstractKey": null
};

(node as any).hash = "103f6cd49e7b747db9f5364bdbb27d8e";

export default node;
